import styled from '@emotion/styled'
import { Text } from 'theme-ui'

import { WithTheme } from './../../../setup/index'

const TradingItemStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const TradingItemIconStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 8.75rem;
  height: 8.75rem;
  border-radius: 50%;
  box-shadow: 0rem 0.1875rem 0.375rem 0rem rgba(0, 0, 0, 0.27);
  margin-bottom: 3.125rem;
`

const TradingItemTitleStyled = styled(Text)<WithTheme>`
  text-align: center;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  margin-bottom: 1.875rem;
`

const TradingItemDescStyled = styled(Text)`
  text-align: center;
`

export { TradingItemStyled, TradingItemIconStyled, TradingItemTitleStyled, TradingItemDescStyled }
